import { useEffect,useState, useRef } from "react";
import { Row, Form, InputGroup} from "react-bootstrap"
import { Card, ListGroup } from "react-bootstrap"
import LableValueDisplay from "../Client/LableValueDisplay"
import Icon from "../Icon/Icon";
import ListGroupTextItem from "../Staff/Elements/ListGroupTextItem";
import EditClientSection1 from "./EditSections/EditClientSection1";
import EditClientSection2 from "./EditSections/EditClientSection2";
import EditClientSection3 from "./EditSections/EditClientSection3";
import CustomerContacts from "./CustomerContacts";

  const PersonalDetails = ({datainfo}) => {
  const [data, setData] = useState(datainfo);   
  const [editMode, setEditMode] = useState(false);
  const modalForm = useRef(null);
  const[showAddEdit, setShowAddEdit] = useState(false);
  const[showAddEdit2, setShowAddEdit2] = useState(false);
  const[showAddEdit3, setShowAddEdit3] = useState(false);
  const [editMode2, setEditMode2] = useState(false);


function HandleEditClick(){  
  setShowAddEdit(true)
}
function HandleEditClick2(){
  setShowAddEdit2(true)
}

function HandleEditClick3(){  
  setShowAddEdit3(true)
}

function handleFormSubmit(event){}

  let isClientAwareOfReferralDisplay = "No"
  if(data && data.isClientAwareOfReferral==1){
    isClientAwareOfReferralDisplay = "Yes"
  }
  
  const fullname = data.title +' '+ data.firstName +' '+ data.lastName;
  const fulladdress = data.companyAdd1 +', '+ data.companyAdd2 +', '+ data.companyAdd3 +', '+ data.companyAdd4 +', '+ data.postcode;

  return ( 
<><Form ref={modalForm} onSubmit={handleFormSubmit}>
<Row>


  <div className="col-md-5" style={{paddingBottom:"12px"}}>
  <Card>
      <ListGroup variant="flush" style={{paddingTop:"10px"}}>

      
            {!editMode &&             
            <ListGroupTextItem editMode={editMode} id={"Name"} name={"Name"} value={fullname}  />
            }
            {editMode && 
             <InputGroup size="sm">
             <InputGroup.Text>Name</InputGroup.Text>
             <Form.Control id="Title" type="text" defaultValue={data.title??''} placeholder="Title" />
             <Form.Control id="firstName" type="text" defaultValue={data.firstName} placeholder="First Name(s)" />
             <Form.Control id="lastName" type="text" defaultValue={data.lastName} placeholder="Last Name(s)" />
           </InputGroup>
            }

        <ListGroupTextItem editMode={editMode} id={"DOB"} name={"Date of birth"} value={data.dateOfBirth} imputtype={"date"} />
        <ListGroupTextItem editMode={editMode} id={"Gender"} name={"Gender"} value={data.gender}  />
        <ListGroupTextItem editMode={editMode} id={"NHSNumber"} name={"NHS Number"} value={data.hnsNumber}  />
        <ListGroupTextItem editMode={editMode} id={"Phone"} name={"Phone"} value={data.companyTelNo}  />
        <ListGroupTextItem editMode={editMode} id={"Mobile"} name={"Mobile"} value={data.mobileNo}  />
        <ListGroupTextItem editMode={editMode} id={"eMail"} name={"eMail"} value={data.emailAddress}  />
        <ListGroupTextItem editMode={editMode} id={"address"} name={"Address"} value={fulladdress}  />
        {!editMode && <div><span onClick={HandleEditClick}  style={{cursor:"pointer", color:"green", paddingLeft:"10px", paddingTop:"5px"}}>Edit <Icon name="edit"></Icon></span></div>}
                  
      </ListGroup>

      <ListGroup variant="flush" style={{paddingTop:"10px"}}>      
          <ListGroupTextItem editMode={editMode} id={"Medical Notes"} name={"Medical Notes"} value={data.medicalNotes} />          
          <ListGroupTextItem editMode={editMode} id={"Likes"} name={"Likes"} value={data.likes} />
          <ListGroupTextItem editMode={editMode} id={"Dis-Likes"} name={"Dis-Likes"} value={data.disLikes} />
          <ListGroupTextItem editMode={editMode} id={"Special Requirments"} name={"Special Requirments"} value={data.specialRequirments} />
          {!editMode && <div><span onClick={HandleEditClick2}  style={{cursor:"pointer", color:"green", paddingLeft:"10px", paddingTop:"5px"}}>Edit <Icon name="edit"></Icon></span></div>}

      </ListGroup>    

      <ListGroup variant="flush" style={{paddingTop:"10px"}}>  
        <ListGroupTextItem editMode={editMode} id={"Referral1"} name={"Referral Received Date"} value={data.referralReceivedDate} imputtype="date" />
            <ListGroupTextItem editMode={editMode} id={"Referra2"} name={"Is client aware of Referral"} value={isClientAwareOfReferralDisplay} />
            <ListGroupTextItem editMode={editMode} id={"Referra3"} name={"Contract Date"} value={data.contractDate}  imputtype={"date"} />
            <ListGroupTextItem editMode={editMode} id={"Referra4"} name={"Service Start Date"} value={data.serviceStartDate}  imputtype={"date"} />
            <ListGroupTextItem editMode={editMode} id={"Referra5"} name={"Service End Date"} value={data.serviceEndDate}  imputtype={"date"} />
            <ListGroupTextItem editMode={editMode} id={"Referra6"} name={"Region"} value={data.region} />
            {!editMode && <div><span onClick={HandleEditClick3}  style={{cursor:"pointer", color:"green", paddingLeft:"10px", paddingTop:"5px"}}>Edit <Icon name="edit"></Icon></span></div>}
      </ListGroup>    

  </Card>
  </div>
  
  <div className="col-md-5" style={{paddingBottom:"12px"}}>
  <Card>      
      <ListGroup variant="flush">
      <ListGroup.Item>
        <CustomerContacts data={datainfo} ShowClientAddress={false} />
        </ListGroup.Item>
      </ListGroup>    
  </Card>
  </div>

</Row>

</Form>

{showAddEdit && <EditClientSection1 show={showAddEdit} setShowAddEdit={setShowAddEdit} data={data} setdata={setData}/>}
{showAddEdit2 && <EditClientSection2 show={showAddEdit2} setShowAddEdit={setShowAddEdit2} data={data} setdata={setData}/>}
{showAddEdit3 && <EditClientSection3 show={showAddEdit3} setShowAddEdit={setShowAddEdit3} data={data} setdata={setData}/>}

   </>  

  )
}

export default PersonalDetails